import { render } from "./SearchHistory.vue?vue&type=template&id=91ca0888"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__